import { en } from './en';
import { fr } from './fr';

const dictionaries: Record<string, Record<string, any>> = {
  en,
  fr,
};

export class Localization {
  private selectedLanguage: string;

  constructor(selectedLanguage: string) {
    this.selectedLanguage = selectedLanguage;
  }

  public translate(key: string): string {
    const dictionary = dictionaries[this.selectedLanguage];
    if (!dictionary) {
      return `Missing dictionary for language: "${this.selectedLanguage}"`;
    }

    // Support nested keys using dot notation (e.g., "damageDetailSummary.header")
    const keys = key.split('.');
    let value: any = dictionary;

    for (const k of keys) {
      value = value?.[k];
      if (value === undefined) {
        return `Missing translation for key: "${key}"`;
      }
    }

    return typeof value === 'string' ? value : `Invalid translation value for key: "${key}"`;
  }

  public setLanguage(language: string): void {
    if (!dictionaries[language]) {
      throw new Error(`Unsupported language: "${language}"`);
    }
    this.selectedLanguage = language;
  }

  public getFromListByKey(listName: string, key: string, defaultValue: string): string {
    const dictionary = dictionaries[this.selectedLanguage];
    if (!dictionary) {
      return `Missing dictionary for language: "${this.selectedLanguage}"`;
    }

    const list = dictionary[listName];
    if (!list) {
      return `Missing list for name: "${listName}"`;
    }

    const value = list[key];
    if (value === undefined) {
      return defaultValue;
    }

    return value;
  }
}